import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Send, Loader2, CheckCircle2, Sparkles } from "lucide-react";
import Logo from "@/components/Logo";

const INTERESTS = [
  { v: "estudiante", l: "Inscribir a un estudiante" },
  { v: "colegio", l: "Convenio con mi colegio" },
  { v: "franquicia", l: "Abrir una franquicia" },
  { v: "otro", l: "Otra consulta" },
];

export default function ContactoLanding() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", city: "", interest: "estudiante", message: "" });
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim()) { toast.error("Nombre y correo son obligatorios."); return; }
    setSending(true);
    try {
      await api.post("/marketing/leads", { ...form, source: "landing" });
      setDone(true);
    } catch {
      toast.error("No se pudo enviar. Revisa el correo e inténtalo de nuevo.");
    } finally { setSending(false); }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="min-h-screen bg-[#FAFBFE] flex items-center justify-center p-4" data-testid="contacto-landing">
      <div className="w-full max-w-lg">
        <div className="flex justify-center mb-6"><Logo size={44} /></div>
        <div className="jasq-card p-7">
          {done ? (
            <div className="text-center py-8" data-testid="contacto-success">
              <CheckCircle2 size={56} className="text-[#16A34A] mx-auto mb-3" />
              <h2 className="font-display text-2xl font-extrabold text-[#1F2547]">¡Gracias! 🎉</h2>
              <p className="text-sm text-[#6E7591] mt-2">Recibimos tu solicitud. Nuestro equipo te contactará muy pronto.</p>
              <Link to="/" className="inline-block mt-5 text-sm font-bold text-[#A43790] hover:underline">Volver al inicio</Link>
            </div>
          ) : (
            <>
              <p className="text-xs tracking-[0.18em] uppercase font-bold text-[#A43790] flex items-center gap-1"><Sparkles size={13} /> Neuromatemáticas JASQ®</p>
              <h1 className="font-display text-3xl font-extrabold text-[#1F2547] mt-1">Aprende matemáticas sintiendo, pensando y creciendo</h1>
              <p className="text-sm text-[#6E7591] mt-2 mb-5">Déjanos tus datos y te contactamos para contarte cómo empezar.</p>
              <form onSubmit={submit} className="space-y-3">
                <input data-testid="lead-name" value={form.name} onChange={set("name")} placeholder="Nombre completo *" className="w-full px-3 py-2.5 rounded-xl border-2 border-[#E1E5F0] text-sm focus:border-[#A43790] outline-none" />
                <div className="grid sm:grid-cols-2 gap-3">
                  <input data-testid="lead-email" type="email" value={form.email} onChange={set("email")} placeholder="Correo *" className="w-full px-3 py-2.5 rounded-xl border-2 border-[#E1E5F0] text-sm focus:border-[#A43790] outline-none" />
                  <input data-testid="lead-phone" value={form.phone} onChange={set("phone")} placeholder="Teléfono" className="w-full px-3 py-2.5 rounded-xl border-2 border-[#E1E5F0] text-sm focus:border-[#A43790] outline-none" />
                </div>
                <div className="grid sm:grid-cols-2 gap-3">
                  <input data-testid="lead-city" value={form.city} onChange={set("city")} placeholder="Ciudad" className="w-full px-3 py-2.5 rounded-xl border-2 border-[#E1E5F0] text-sm focus:border-[#A43790] outline-none" />
                  <select data-testid="lead-interest" value={form.interest} onChange={set("interest")} className="w-full px-3 py-2.5 rounded-xl border-2 border-[#E1E5F0] text-sm focus:border-[#A43790] outline-none bg-white">
                    {INTERESTS.map((i) => <option key={i.v} value={i.v}>{i.l}</option>)}
                  </select>
                </div>
                <textarea data-testid="lead-message" value={form.message} onChange={set("message")} placeholder="Cuéntanos qué necesitas" rows={3} className="w-full px-3 py-2.5 rounded-xl border-2 border-[#E1E5F0] text-sm focus:border-[#A43790] outline-none" />
                <button type="submit" disabled={sending} data-testid="lead-submit"
                  className="w-full inline-flex items-center justify-center gap-2 px-4 py-3 rounded-2xl bg-[#A43790] text-white font-bold hover:bg-[#D63384] transition-colors disabled:opacity-60">
                  {sending ? <Loader2 size={18} className="animate-spin" /> : <Send size={18} />} Quiero información
                </button>
              </form>
              <p className="text-center text-xs text-[#A6ACC1] mt-4"><Link to="/" className="hover:underline">¿Ya tienes cuenta? Inicia sesión</Link></p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
